import React, { useState, useEffect } from "react";
import makeRequest from "../../utils/makeRequest";
import * as urls from "../../utils/URLConst";
import { Button, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { handleLoader } from "../../redux/reducers/layout";
import toastNotify from "../../utils/ToastNotify";

const EscalationMatrixModal = ({
  isOpen,
  handleIsExcelationMatrixMdl,
  itemCodeData,
}) => {

  const [apidataMatrix, setApiDataMatrix] = useState([]);
  const dispatch = useDispatch();

  async function fetchEscalationMatrix() {
    try {
      dispatch(handleLoader(true));
      const data = {
        ITEM_CD: itemCodeData,
      };
      const result = await makeRequest("POST", urls.getEscalationMatrix, data, {});

      if (result.STATUS == "0") {
        const response = result.RESPONSE[0].LEVEL_DTL;
        setApiDataMatrix(response);
      } else {
        result.MESSAGE !== "Not found!" && toastNotify(result.MESSAGE, "error");
      }
    } catch (error) {
      // Ignore Case
    } finally {
      dispatch(handleLoader(false));
    }
  }

  const columns = [
    {
      field: "LEVEL",
      headerNm: "level",
      textAlign: "center",
    },
    {
      field: "NAME",
      headerNm: "Name",
      textAlign: "left",
    },
    {
      field: "EMAIL",
      headerNm: "Email",
      textAlign: "left",
    },
    {
      field: "MOBILE",
      headerNm: "Mobile No.",
      textAlign: "left",
    },
  ];

  useEffect(() => {
    fetchEscalationMatrix();
  }, []);

  return (
    <Modal
      backdrop="static"
      keyboard={false}
      show={isOpen}
      onHide={handleIsExcelationMatrixMdl}
    >
      <Modal.Header closeButton>
        <Modal.Title>Escalation Matrix</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="table-responsive" style={{ height: "100%" }}>
          <table className="data-table table  table-hover table-responsive text-nowrap">
            <thead>
              <tr>
                {columns.map((column, index) => (
                  <th
                    key={index}
                    style={{ textAlign: column.textAlign }}
                  >
                    {column.headerNm}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {apidataMatrix.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {columns.map((column, colIndex) => {
                    return (
                      <td
                        key={colIndex}
                        className="data-cell"
                        style={{ textAlign: column.textAlign }}
                      >
                        {row[column.field]}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
          {apidataMatrix.length === 0 && (
            <>
              <div className="d-flex justify-content-center NoData-image">
                <img
                  src="./assets/images/No-data.jpg"
                  alt=""
                  className="NoData-Size"
                />
              </div>
              <div className="d-flex justify-content-center">
                <h4 className="mt-3"> No Data Found </h4>
              </div>
            </>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer className="modal-footer py-2">
        <Button
          type="button"
          variant="secondary"
          className="btn-sm"
          onClick={() => handleIsExcelationMatrixMdl()}
          data-dismiss="modal"
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal >
  );
};

export default EscalationMatrixModal;
